"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconPointerDown = _interopRequireDefault(require("./IconPointerDown"));
var IconPointerUp = /*#__PURE__*/(0, _styledComponents.default)(_IconPointerDown.default).withConfig({
  displayName: "IconPointerUp",
  componentId: "c11n-8-107-0__sc-vfw4gs-0"
})(["transform:rotate(180deg);"]);
var _default = IconPointerUp;
exports.default = _default;